export default __webpack_public_path__ + "static/media/book_bg.04928df2.png";